import React, { useMemo } from "react";
import { Alert } from "react-bootstrap";
import { FiltersBar } from "./FiltersBar";
import { DataTable } from "./DataTable";
import { ReportToolbar } from "./ReportToolbar";
import { GroupCollabChart } from "./GroupCollabChart";
import { useCSReportRunner } from "./useCSReportRunner";
import {
  downloadStudentCollabTrendCSV,
  fetchStudentCollabTrend,
} from "./csReportsApi";
import {
  buildReportParams,
  deriveColumns,
  validateBaseFilters,
} from "./reportHelpers";

export const StudentCollabTrendTab = ({
  filters,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  const runner = useCSReportRunner({
    fetchJson: fetchStudentCollabTrend,
    fetchCsv: downloadStudentCollabTrendCSV,
    errorTag: "student-collab-trend",
  });

  const validation = useMemo(
    () => validateBaseFilters({ filters, startDate, endDate, requireTeacher: true }),
    [filters, startDate, endDate]
  );

  const params = useMemo(() => {
    if (!validation.ok) return null;
    return buildReportParams({ filters, startDate, endDate });
  }, [filters, startDate, endDate, validation.ok]);

  const columns = useMemo(() => deriveColumns(runner.rows), [runner.rows]);

  const showChart = runner.rows && runner.rows.length > 0;

  return (
    <div>
      <FiltersBar
        filters={filters}
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        teacherRequired
      />

      <ReportToolbar
        validation={validation}
        loading={runner.loading}
        downloading={runner.downloading}
        onRun={() => runner.run(params)}
        onDownload={() => runner.download(params)}
      />

      {runner.error && <Alert variant="danger">{String(runner.error)}</Alert>}

      {showChart && (
        <GroupCollabChart
          rows={runner.rows}
          title="Student Math Discourse & Collaboration Scores"
        />
      )}

      {runner.rows !== null && (
        <DataTable
          data={runner.rows}
          columns={columns}
          emptyMessage="No CONSENSUS sessions in this date range for the selected teacher."
        />
      )}
    </div>
  );
};
